import { render, staticRenderFns } from "./candidat.vue?vue&type=template&id=dffb787a"
import script from "./candidat.vue?vue&type=script&lang=js"
export * from "./candidat.vue?vue&type=script&lang=js"
import style0 from "./candidat.vue?vue&type=style&index=0&id=dffb787a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports